import './App.css';
import pro_pic from './img/profile_pic2.jpg';
import React, { Component } from "react";
import ReactRoundedImage from "react-rounded-image";
import Divider from '@material-ui/core/Divider';

function AboutMe() {
  return (
    <div className="wrapper">
        <img src={pro_pic} alt="profile pic" className="profile_pic" />
        <p className="content_page">
        I am a first-year PhD student in computer science at Carnegie Mellon University. <br /><br />

        In Spring 2021, I completed my undergraduate at the University of Kansas where I 
        double-majored in computer science and mathematics, and minored in visual arts (emphasis 
        in painting). While there, I was a research assistant under the guidance of Dr. 
        Suzanne Shontz in scientific computing. <br /><br />

        I am broadly interested in solving problems at the interface of mathematics and 
        computer science. My current research interests include <b>programming languages</b>, <b>type theory</b>, and <b>language design</b>. <br /><br />
        <Divider />
        <br />
        Email: mdotzel [at] andrew [dot] cmu [dot] edu
        Office: GHC 9223
        </p>
      
    </div>
  );
}

export default AboutMe;